(function () {
  var FRAMED_FINISHES = ['Dark Wood', 'Light Wood', 'Black'];
  var UNFRAMED = 'Unframed';
  var NONE = 'None';
  var FRAME_STYLE_POSITION = '2';

  function getRoot(el) {
    return el && el.closest('[data-product-root]');
  }

  function getChecked(root, position) {
    return root.querySelector(
      '[data-single-option-selector][data-position="' + position + '"]:checked'
    );
  }

  function selectOption(root, position, value) {
    var input = root.querySelector(
      '[data-single-option-selector][data-position="' + position + '"][value="' + value.replace(/"/g, '\\"') + '"]'
    );
    if (!input || input.checked) return;
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function clearFrameStyleDecorationsWhenUnframed(root) {
    var frameStyle = getChecked(root, FRAME_STYLE_POSITION);
    if (!frameStyle || frameStyle.value !== UNFRAMED) return;

    root.querySelectorAll(
      '[data-single-option-selector][data-position="' + FRAME_STYLE_POSITION + '"]'
    ).forEach(function (input) {
      if (input.classList.contains('unavailable') || input.classList.contains('sold-out')) {
        input.classList.remove('unavailable', 'sold-out');
      }
    });
  }

  function syncPrintVariantOptions(root) {
    if (!root) return;

    var frameStyle = getChecked(root, FRAME_STYLE_POSITION);
    var finish = getChecked(root, '3');
    if (!frameStyle || !finish) return;

    if (frameStyle.value === UNFRAMED) {
      if (finish.value !== NONE) {
        selectOption(root, '3', NONE);
      }
      clearFrameStyleDecorationsWhenUnframed(root);
      return;
    }

    if (finish.value === NONE) {
      selectOption(root, '3', FRAMED_FINISHES[0]);
    }
  }

  function scheduleSync(root) {
    window.setTimeout(function () {
      syncPrintVariantOptions(root);
    }, 0);
    window.setTimeout(function () {
      clearFrameStyleDecorationsWhenUnframed(root);
    }, 60);
  }

  function onOptionChange(event) {
    var el = event.target;
    if (!el.matches('[data-single-option-selector]')) return;
    var root = getRoot(el);
    if (!root) return;
    scheduleSync(root);
  }

  function initAll() {
    document.querySelectorAll('[data-product-root]').forEach(function (root) {
      if (!root.querySelector('[data-single-option-selector][data-position="3"]')) return;
      scheduleSync(root);
    });
  }

  document.addEventListener('change', onOptionChange);
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
